export default {
  error: state => state.error,
  success: state => state.success,
  loading: state => state.loading,
  suggestedprovident: state => state.suggestedprovident,
  transactionSPA: state => state.transactionSPA,
  suggestedPF: state => state.suggestedPF,
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/SuggestedPF/getters.js